module.exports = __webpack_public_path__ + "tables/media/stocks.bd347da1.svg";